<template>
  <div class="teacher-atten-jump"></div>
</template>

<script>
/**
 * 菜单入口：新窗口打开全屏页 /TeacherAttenBigScreen，并取消后台内嵌跳转
 * 最后更新：2026-08-31
 */
let lastTeacherAttenOpenAt = 0;

export default {
  name: "TeacherAttenBigScreenJump",
  beforeRouteEnter(to, from, next) {
    const now = Date.now();
    if (now - lastTeacherAttenOpenAt < 800) {
      next(false);
      return;
    }
    lastTeacherAttenOpenAt = now;

    const fromQuery = to.query.departmentId;
    const activeId = window.localStorage.getItem("activeSchoolId");
    let departmentId = fromQuery || activeId || "99";
    if (departmentId === "0" || departmentId === 0) departmentId = "99";

    const params = new URLSearchParams({ departmentId: String(departmentId) });
    const url = `${window.location.origin}/TeacherAttenBigScreen?${params.toString()}`;
    window.open(url, "_blank", "noopener");

    // 取消本次菜单路由，留在当前后台页
    if (from.name && from.path !== to.path) {
      next(false);
      return;
    }
    next("/");
  },
};
</script>

<style scoped>
.teacher-atten-jump {
  display: none;
}
</style>
